module.exports = __webpack_public_path__ + "img/freewave2_feature_01.3e868b67.jpg";